import { useState, useEffect, useCallback } from 'react'
import { api, contactsApi } from '../api'
import { useApp } from '../AppContext'
import { FormGroup, Empty, Loading } from '../components/ui'

const TYPES = {
    camera: { label: 'Caméra', icon: 'camera', color: '#1565c0' },
    logiciel: { label: 'Logiciel', icon: 'app-window', color: '#6a1b9a' },
    routeur: { label: 'Routeur', icon: 'router', color: '#e65100' },
    nvr: { label: 'NVR', icon: 'server', color: '#2e7d32' },
    switch: { label: 'Switch', icon: 'git-fork', color: '#00838f' },
    serveur: { label: 'Serveur', icon: 'server-2', color: '#37474f' },
    autre: { label: 'Autre', icon: 'device-unknown', color: '#868e96' },
}

export default function Credentials() {
    const { toast, isAdmin } = useApp()
    const [items, setItems] = useState([])
    const [loading, setLoading] = useState(true)
    const [search, setSearch] = useState('')
    const [typeFilter, setTypeFilter] = useState('')
    const [clientFilter, setClientFilter] = useState('')
    const [contacts, setContacts] = useState([])


    const [modal, setModal] = useState(null)
    const [detail, setDetail] = useState(null)

    const load = useCallback(() => {
        setLoading(true)
        const p = new URLSearchParams()
        if (search) p.set('search', search)
        if (typeFilter) p.set('type', typeFilter)
        if (clientFilter) p.set('contact_id', clientFilter)
        api.get('/credentials?' + p)
            .then(r => setItems(r.data || []))
            .catch(e => toast(e.message, 'error'))
            .finally(() => setLoading(false))
    }, [search, typeFilter, clientFilter])

    useEffect(() => { load() }, [load])
    useEffect(() => {
        contactsApi.list({ per_page: 200 }).then(r => setContacts(r.data || [])).catch(() => { })
    }, [])

    async function del(id, nom) {
        if (!confirm(`Supprimer "${nom}" ?`)) return
        try { await api.delete(`/credentials/${id}`); toast('Supprimé', 'success'); load() }
        catch (e) { toast(e.message, 'error') }
    }

    async function showDetail(id) {
        try {
            const r = await api.get(`/credentials/${id}`)
            setDetail(r.data)
        } catch (e) { toast(e.message, 'error') }
    }

    return (
        <div className="content">
            {/* Toolbar */}
            <div style={{ display: 'flex', alignItems: 'center', gap: 10, marginBottom: 16, flexWrap: 'wrap' }}>
                <div className="search-box">
                    <i className="ti ti-search" />
                    <input placeholder="Rechercher…" value={search} onChange={e => setSearch(e.target.value)} />
                </div>
                <select className="form-control" style={{ width: 160 }} value={typeFilter} onChange={e => setTypeFilter(e.target.value)}>
                    <option value="">Tous les types</option>
                    {Object.entries(TYPES).map(([v, t]) => <option key={v} value={v}>{t.label}</option>)}
                </select>
                <select className="form-control" style={{ width: 200 }} value={clientFilter} onChange={e => setClientFilter(e.target.value)}>
                    <option value="">Tous les clients</option>
                    {contacts.map(c => <option key={c.id} value={c.id}>{c.nom}</option>)}
                </select>
                <span style={{ color: 'var(--text3)', fontSize: 13, marginLeft: 'auto' }}>{items.length} credential(s)</span>
                {
                    <button className="btn primary" onClick={() => setModal({})}>
                        <i className="ti ti-plus" /> Nouveau
                    </button>}
            </div>

            {/* Grille */}
            {loading ? <Loading /> : items.length === 0 ? (
                <Empty icon="key-off" message="Aucun credential enregistré" />
            ) : (
                <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(280px, 1fr))', gap: 12 }}>
                    {items.map(c => {
                        const t = TYPES[c.type] || TYPES.autre
                        return (
                            <div key={c.id} style={{ background: 'var(--bg)', border: '1px solid var(--border)', borderTop: `3px solid ${t.color}`, borderRadius: 'var(--radius-lg)', padding: '14px 16px', cursor: 'pointer' }}
                                onClick={() => showDetail(c.id)}>
                                <div style={{ display: 'flex', alignItems: 'flex-start', justifyContent: 'space-between', marginBottom: 10 }}>
                                    <div style={{ display: 'flex', alignItems: 'center', gap: 9 }}>
                                        <div style={{ width: 36, height: 36, borderRadius: 8, background: t.color + '18', color: t.color, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                                            <i className={`ti ti-${t.icon}`} style={{ fontSize: 18 }} />
                                        </div>
                                        <div>
                                            <div style={{ fontWeight: 600, fontSize: 13 }}>{c.nom}</div>
                                            <div style={{ fontSize: 11, color: t.color, fontWeight: 600 }}>{t.label}</div>
                                        </div>
                                    </div>
                                    {isAdmin && (
                                        <div style={{ display: 'flex', gap: 4 }} onClick={e => e.stopPropagation()}>
                                            <button className="btn sm" onClick={() => setModal(c)}><i className="ti ti-edit" /></button>
                                            <button className="btn sm" onClick={() => del(c.id, c.nom)}><i className="ti ti-trash" style={{ color: 'var(--danger)' }} /></button>
                                        </div>
                                    )}
                                </div>

                                {c.ip_adresse && (
                                    <div style={{ fontSize: 12, color: 'var(--text2)', marginBottom: 4 }}>
                                        <i className="ti ti-network" style={{ marginRight: 4 }} />
                                        {c.ip_adresse}{c.port ? `:${c.port}` : ''}
                                    </div>
                                )}
                                {c.login && (
                                    <div style={{ fontSize: 12, color: 'var(--text2)', marginBottom: 4 }}>
                                        <i className="ti ti-user" style={{ marginRight: 4 }} />{c.login}
                                    </div>
                                )}
                                {c.localisation && (
                                    <div style={{ fontSize: 12, color: 'var(--text3)' }}>
                                        <i className="ti ti-map-pin" style={{ marginRight: 4 }} />{c.localisation}
                                    </div>
                                )}
                                {c.contact_nom && (
                                    <div style={{ marginTop: 8, paddingTop: 8, borderTop: '1px solid var(--border)', fontSize: 12, color: 'var(--primary)' }}>
                                        <i className="ti ti-building" style={{ marginRight: 4 }} />{c.contact_nom}
                                    </div>
                                )}
                            </div>
                        )
                    })}
                </div>
            )}

            {/* Modal création/édition */}
            {modal !== null &&(
                <CredentialModal
                    credential={modal}
                    onClose={() => setModal(null)}
                    onSaved={() => { load(); setModal(null); toast('Credential enregistré', 'success') }}
                />
            )}

            {/* Modal détail avec mot de passe */}
            {detail && (
                <CredentialDetail
                    credential={detail}
                    onClose={() => setDetail(null)}
                    onEdit={ () => { setModal(detail); setDetail(null) }}
                />
            )}
        </div>
    )
}

// ── Modal détail (avec mot de passe déchiffré) ────────────────
function CredentialDetail({ credential: c, onClose, onEdit }) {
    const [showPass, setShowPass] = useState(false)
    const [copied, setCopied] = useState('')
    const t = TYPES[c.type] || TYPES.autre

    function copy(text, key) {
        navigator.clipboard.writeText(text).then(() => {
            setCopied(key)
            setTimeout(() => setCopied(''), 2000)
        })
    }

    const Row = ({ label, value, copyKey }) => value ? (
        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', padding: '9px 0', borderBottom: '1px solid var(--border)' }}>
            <span style={{ fontSize: 11, fontWeight: 600, color: 'var(--text3)', width: 110 }}>{label}</span>
            <span style={{ fontSize: 13, flex: 1 }}>{value}</span>
            {copyKey && (
                <button className="btn sm" onClick={() => copy(value, copyKey)} style={{ marginLeft: 8 }}>
                    <i className={`ti ti-${copied === copyKey ? 'check' : 'copy'}`} style={{ color: copied === copyKey ? 'var(--success)' : undefined }} />
                </button>
            )}
        </div>
    ) : null

    return (
        <div className="overlay" onClick={e => e.target === e.currentTarget && onClose()}>
            <div className="modal" style={{ maxWidth: 500 }}>
                <div className="modal-header">
                    <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
                        <div style={{ width: 38, height: 38, borderRadius: 8, background: t.color + '18', color: t.color, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                            <i className={`ti ti-${t.icon}`} style={{ fontSize: 20 }} />
                        </div>
                        <div>
                            <div className="modal-title">{c.nom}</div>
                            <div style={{ fontSize: 11, color: t.color, fontWeight: 600 }}>{t.label}</div>
                        </div>
                    </div>
                    <div style={{ display: 'flex', gap: 6 }}>
                        {onEdit && <button className="btn sm" onClick={onEdit}><i className="ti ti-edit" /></button>}
                        <button className="btn sm icon" onClick={onClose}><i className="ti ti-x" /></button>
                    </div>
                </div>
                <div className="modal-body">
                    <Row label="IP / Adresse" value={c.ip_adresse ? `${c.ip_adresse}${c.port ? ':' + c.port : ''}` : null} copyKey="ip" />
                    <Row label="Login" value={c.login} copyKey="login" />
                    {c.password_dec && (
                        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', padding: '9px 0', borderBottom: '1px solid var(--border)' }}>
                            <span style={{ fontSize: 11, fontWeight: 600, color: 'var(--text3)', width: 110 }}>Mot de passe</span>
                            <span style={{ fontSize: 13, flex: 1, fontFamily: 'monospace', letterSpacing: showPass ? 0 : 3 }}>
                                {showPass ? c.password_dec : '••••••••••'}
                            </span>
                            <div style={{ display: 'flex', gap: 4, marginLeft: 8 }}>
                                <button className="btn sm" onClick={() => setShowPass(p => !p)}>
                                    <i className={`ti ti-eye${showPass ? '-off' : ''}`} />
                                </button>
                                <button className="btn sm" onClick={() => copy(c.password_dec, 'pass')}>
                                    <i className={`ti ti-${copied === 'pass' ? 'check' : 'copy'}`} style={{ color: copied === 'pass' ? 'var(--success)' : undefined }} />
                                </button>
                            </div>
                        </div>
                    )}
                    <Row label="Localisation" value={c.localisation} />
                    <Row label="Client" value={c.contact_nom} />
                    {c.notes && (
                        <div style={{ marginTop: 12 }}>
                            <p style={{ fontSize: 11, fontWeight: 600, color: 'var(--text3)', marginBottom: 6 }}>NOTES</p>
                            <p style={{ fontSize: 13, color: 'var(--text2)', lineHeight: 1.7, whiteSpace: 'pre-line' }}>{c.notes}</p>
                        </div>
                    )}
                </div>
            </div>
        </div>
    )
}

// ── Modal création/édition credential ─────────────────────────
function CredentialModal({ credential, onClose, onSaved }) {
    const { toast } = useApp()
    const [form, setForm] = useState({ type: 'camera', nom: '', ip_adresse: '', port: '', login: '', password: '', localisation: '', notes: '', contact_id: '', ...(credential || {}) })
    const [contacts, setContacts] = useState([])
    const [saving, setSaving] = useState(false)
    const [showPass, setShowPass] = useState(false)
    const f = k => e => setForm(p => ({ ...p, [k]: e.target.value }))

    useEffect(() => {
        contactsApi.list({ per_page: 200 }).then(r => setContacts(r.data || [])).catch(() => { })
    }, [])

    async function save(e) {
        e.preventDefault(); setSaving(true)
        try {
            if (credential?.id) await api.put(`/credentials/${credential.id}`, form)
            else await api.post('/credentials', form)
            onSaved()
        } catch (err) { toast(err.message, 'error') }
        finally { setSaving(false) }
    }

    return (
        <div className="overlay" onClick={e => e.target === e.currentTarget && onClose()}>
            <div className="modal" style={{ maxWidth: 520 }}>
                <div className="modal-header">
                    <span className="modal-title">{credential?.id ? 'Modifier' : 'Nouveau credential'}</span>
                    <button className="btn sm icon" onClick={onClose}><i className="ti ti-x" /></button>
                </div>
                <form onSubmit={save}>
                    <div className="modal-body">
                        <div className="grid2">
                            <FormGroup label="Nom" required>
                                <input className="form-control" value={form.nom || ''} onChange={f('nom')} required placeholder="Ex: DVR Hôtel Azur" />
                            </FormGroup>
                            <FormGroup label="Type">
                                <select className="form-control" value={form.type} onChange={f('type')}>
                                    {Object.entries(TYPES).map(([v, t]) => <option key={v} value={v}>{t.label}</option>)}
                                </select>
                            </FormGroup>
                        </div>
                        <div className="grid2">
                            <FormGroup label="IP / Adresse">
                                <input className="form-control" value={form.ip_adresse || ''} onChange={f('ip_adresse')} placeholder="192.168.1.1" />
                            </FormGroup>
                            <FormGroup label="Port">
                                <input className="form-control" value={form.port || ''} onChange={f('port')} placeholder="8080" />
                            </FormGroup>
                        </div>
                        <div className="grid2">
                            <FormGroup label="Login">
                                <input className="form-control" value={form.login || ''} onChange={f('login')} placeholder="admin" />
                            </FormGroup>
                            <FormGroup label="Mot de passe">
                                <div style={{ position: 'relative' }}>
                                    <input
                                        type={showPass ? 'text' : 'password'}
                                        className="form-control"
                                        value={form.password || ''}
                                        onChange={f('password')}
                                        placeholder={credential?.id ? 'Laisser vide pour ne pas changer' : ''}
                                        style={{ paddingRight: 36 }}
                                    />
                                    <button type="button" onClick={() => setShowPass(p => !p)}
                                        style={{ position: 'absolute', right: 8, top: '50%', transform: 'translateY(-50%)', background: 'none', border: 'none', cursor: 'pointer', color: 'var(--text3)' }}>
                                        <i className={`ti ti-eye${showPass ? '-off' : ''}`} />
                                    </button>
                                </div>
                            </FormGroup>
                        </div>
                        <FormGroup label="Localisation">
                            <input className="form-control" value={form.localisation || ''} onChange={f('localisation')} placeholder="Ex: Salle serveur, Bureau RDC…" />
                        </FormGroup>
                        <FormGroup label="Client lié">
                            <select className="form-control" value={form.contact_id || ''} onChange={f('contact_id')}>
                                <option value="">— Aucun —</option>
                                {contacts.map(c => <option key={c.id} value={c.id}>{c.nom}</option>)}
                            </select>
                        </FormGroup>
                        <FormGroup label="Notes techniques">
                            <textarea className="form-control" rows={3} value={form.notes || ''} onChange={f('notes')} placeholder="Accès, configuration, remarques…" />
                        </FormGroup>
                    </div>
                    <div className="modal-footer">
                        <button type="button" className="btn" onClick={onClose}>Annuler</button>
                        <button type="submit" className="btn primary" disabled={saving}>{saving ? '…' : 'Enregistrer'}</button>
                    </div>
                </form>
            </div>
        </div>
    )
}